import type { ReactElement } from "react"
import styled from "styled-components"
import { LibrarySortType } from "~/graphql/generated/graphql"

/** RELEVANCE is omitted — it only means anything alongside a searchTerm. */
const SORT_OPTIONS: readonly { readonly value: LibrarySortType; readonly label: string }[] = [
  { value: LibrarySortType.AddedAtDesc, label: "Recently added" },
  { value: LibrarySortType.AddedAtAsc, label: "Oldest first" },
  { value: LibrarySortType.TitleAsc, label: "Title (A–Z)" },
  { value: LibrarySortType.TitleDesc, label: "Title (Z–A)" },
]

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
`

const Label = styled.label`
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textSecondary};
`

const Select = styled.select`
  padding: ${({ theme }) => `${theme.spacing.xxs} ${theme.spacing.xs}`};
  border: 1px solid ${({ theme }) => theme.color.border};
  border-radius: ${({ theme }) => theme.radius.sm};
  background-color: ${({ theme }) => theme.color.controlSurface};
  font-size: ${({ theme }) => theme.fontSize.xs};
`

interface LibrarySortSelectorProps {
  readonly id: string
  readonly value: LibrarySortType
  readonly onChange: (sortBy: LibrarySortType) => void
  readonly qaHook: string
}

export const LibrarySortSelector = ({ id, value, onChange, qaHook }: LibrarySortSelectorProps): ReactElement => (
  <Wrapper>
    <Label htmlFor={id}>Sort</Label>
    <Select
      id={id}
      value={value}
      data-qa-hook={qaHook}
      onChange={event => onChange(event.target.value as LibrarySortType)}
    >
      {SORT_OPTIONS.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  </Wrapper>
)
